import { getApiClient, initializeApiClient } from "../../../apiService";

export const AddPalestinianGovernoratesProjectActivities = async (
  tG_PalestinianGovernoratesNameId,
  tG_MainTargetedGroupId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/TG_PalestinianGovernoratesProjectActivities/AddTG_PalestinianGovernoratesProjectActivitiesData`,
    {
      tG_PalestinianGovernoratesNameId: tG_PalestinianGovernoratesNameId,
      tG_MainTargetedGroupId: tG_MainTargetedGroupId,
    }
  );

  return response;
};

export default AddPalestinianGovernoratesProjectActivities;
